import React, { useState } from 'react'
import { ProdottoNode } from '@gql/graphql'
import useTrans from '@hooks/useTrans'
import useWishlist from '@hooks/useWishlist'
import { Cart } from '@utils/cartContext'
import { FavoriteMarked, FavoriteUnmarked } from '@components/icons'
import WishlistModal from '../WishlistModal/WishlistModal'
import styles from './WishlistButton.module.sass'

interface Props {
  prodotto?: ProdottoNode
  cart?: Cart
  className?: string
}

const WishlistButton = (props: Props) => {
  const { prodotto = undefined, cart = undefined, className = '' } = props

  const t = useTrans()
  const { enabled, marked, toggleWishlist } = useWishlist(prodotto)
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        onClick={enabled ? toggleWishlist : () => setModalOpen(true)}
        aria-label={t(marked ? 'Rimuovi dai preferiti' : 'Aggiungi ai preferiti')}
        className={`${styles.root} ${className}`}
      >
        {marked ? <FavoriteMarked /> : <FavoriteUnmarked />}
      </button>

      <WishlistModal
        id={`wishlist_button_modal_${prodotto.pk}`}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        prodottoId={prodotto.pk}
      />
    </>
  )
}

export default WishlistButton
